<template>
  <div class="table-responsive">
    <p>
      Segue abaixo a exibição do histórico de alterações do cliente.
    </p>
    <div class="container-table">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="text-center" style="width: 50px; white-space: nowrap;">Alterado por</th>
            <th class="text-center" style="width: 10px; white-space: nowrap;">Ação</th>
            <th class="text-center" style="width: 50px; white-space: nowrap;">Campos alterados</th>
            <th class="text-center" style="width: 10px; white-space: nowrap;">Data</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(audit, index) in data">
            <tr data-toggle="collapse" :data-target="'#fields' + index" class="clickable pointer" :key="index">
              <td class="text-center">{{ audit.name }}</td>
              <td class="text-center">{{ getAuditAction(audit) }}</td>
              <td class="text-left">{{ getModifiedFieldsCount(audit) }}</td>
              <td class="text-center">{{ audit.event_date | datetimeMinuteUtcToBr }}</td>
            </tr>
            <tr class="collapse out" :id="'fields' + index" :key="'values' + index">
              <td colspan="4">
                <CustomerHistoryValuesTable :auditData="audit" />
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { customerFieldsLabelMixin } from '@/mixins/customerFieldsLabelMixin';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import CustomerHistoryValuesTable from '@/components/customers/CustomerHistoryValuesTable';

export default {
  mixins: [returnMessageFormMixin, customerFieldsLabelMixin],
  name: 'CustomerContractHistory',
  components: { CustomerHistoryValuesTable },
  data() {
    return {
      data: [],
      page: 1,
    };
  },
  methods: {
    getAuditAction(item) {
      if (!item.audits || item.audits.length === 0) {
        return 'Atualizado';
      }

      const audit = item.audits[0];

      if (audit.event) {
        switch (audit.event) {
          case 'created':
            return 'Criado';
          case 'updated':
            return 'Atualizado';
          case 'deleted':
            return 'Excluído';
          case 'updated_by_non_payment':
            return 'Status alterado por inadimplência';  
          case 'cancelled_by_blocked_60_days':
            return 'Cancelado por bloqueio de 60 dias';
          case 'auto_termination_started':
            return 'Finalização automática iniciada';
          case 'auto_cancelled_by_finish_date':
            return 'Cancelado pela data de finalização automática';
          default:
            return audit.event;
        }
      }

      return 'Atualizado';
    },
    getModifiedFieldsCount(item) {
      if (!item.audits || item.audits.length === 0) {
        return '-';
      }

      const audits = item.audits;

      if (audits.some(audit => audit.new_values && audit.old_values)) {
        const allFields = new Set();

        audits.forEach(audit => {
          if (audit.new_values && audit.old_values) {
            Object.keys(audit.new_values).forEach(field => allFields.add(field));
            Object.keys(audit.old_values).forEach(field => allFields.add(field));
          }
        });

        const fieldNames = Array.from(allFields).map(field => this.getFieldLabel(field));
        return fieldNames.join(', ');
      }

      if (audits[0] && audits[0].field) {
        const fieldNames = audits.map(auditItem => this.getFieldLabel(auditItem.field));
        return fieldNames.join(', ');
      }

      return '-';
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/customer-status/${this.customerId}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
  },
  beforeMount() {
    if (this.customerId) {
      this.getDatas();
    }
  },
  computed: {
    customerId() {
      return this.$store.state.showCustomerSave;
    },
  },
};
</script>
